var map = {
	"./erp-logos-solbox.jpg": "acbe",
	"./erp-logos_0000_dear.jpg": "90a2",
	"./erp-logos_0001_zoho.jpg": "a9f9",
	"./erp-logos_0002_xero.jpg": "ecd5",
	"./erp-logos_0003_woocommerce.jpg": "268e",
	"./erp-logos_0004_wiise.jpg": "6339",
	"./erp-logos_0005_vintrace.jpg": "b768",
	"./erp-logos_0006_unleashed.jpg": "9687",
	"./erp-logos_0007_tradegecko.jpg": "956e",
	"./erp-logos_0008_tencia.jpg": "9d67",
	"./erp-logos_0009_storefeeder.jpg": "d03c",
	"./erp-logos_0010_spire.jpg": "d292",
	"./erp-logos_0011_shopify.jpg": "30f2",
	"./erp-logos_0012_saphana.jpg": "3641",
	"./erp-logos_0013_sapb1.jpg": "224a",
	"./erp-logos_0014_sageone.jpg": "172d",
	"./erp-logos_0015_sagebc.jpg": "a6de",
	"./erp-logos_0016_sage300.jpg": "5f2b",
	"./erp-logos_0017_sage200.jpg": "8593",
	"./erp-logos_0018_sage100.jpg": "0063",
	"./erp-logos_0019_sage50.jpg": "29e9",
	"./erp-logos_0020_reckon.jpg": "42a0",
	"./erp-logos_0021_quickbooks.jpg": "cf00",
	"./erp-logos_0022_pronto.jpg": "d7ec",
	"./erp-logos_0023_pepperi.jpg": "2586",
	"./erp-logos_0024_odoo.jpg": "25c5",
	"./erp-logos_0025_netsuite.jpg": "6b1c",
	"./erp-logos_0026_neto.jpg": "b9be",
	"./erp-logos_0027_dynamicsnav.jpg": "9542",
	"./erp-logos_0028_myob.jpg": "8203",
	"./erp-logos_0029_maropost.jpg": "f784",
	"./erp-logos_0030_jiwa.jpg": "d4e2",
	"./erp-logos_0031_jcurve.jpg": "8261",
	"./erp-logos_0032_freshbooks.jpg": "fa81",
	"./erp-logos_0033_fishbowl.jpg": "1b1f",
	"./erp-logos_0034_epicor.jpg": "2ced",
	"./erp-logos_0035_datapel.jpg": "1f31",
	"./erp-logos_0036_commerce7.jpg": "12b7",
	"./erp-logos_0037_cin7.jpg": "1c85",
	"./erp-logos_0038_cartoncloud.jpg": "0e36",
	"./erp-logos_0039_businesscentral.jpg": "33b3",
	"./erp-logos_0040_acumatica.jpg": "9fb2",
	"./erp-logos_0041_access.jpg": "0855",
	"./myob-exo.jpg": "0ce0",
	"./neo-logo.png": "bcca",
	"./pipeliner-logo.png": "78dc",
	"./sellercloud-logo.jpeg": "6ecb",
	"./sellercloud-logo.png": "9b38",
	"./stocktrim.jpeg": "6e63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";